import { format as formatDate } from 'date-fns';
import { getDateFnsLocale } from '../../helpers/getDateFnsLocale';

export function getFormattedDate(
  date: string,
  format = 'dd MMM yyyy',
  locale?: string,
) {
  const createdDate = new Date(date);
  const dateFnsLocale = locale ? getDateFnsLocale(locale) : undefined;

  return formatDate(createdDate, format, {
    locale: dateFnsLocale,
  });
}
